import React, {useCallback} from "react"
import {useNavigate, useParams} from "react-router-dom"
import {useConfig} from "../../hooks/useConfig"
import {useBoothSession} from "../../hooks/useBoothSession"
import PicView from "../views/PicView"

function PicPage() {
  const params = useParams<"code" | "uploadCode" | "picPresentation">()
  const code = params.code!
  const uploadCode = params.uploadCode!
  const presentation = params.picPresentation ?? "view"
  const navigate = useNavigate()

  const {config, loading} = useConfig(code)
  const {clearImages} = useBoothSession(config?.presetCode ?? code)

  const resetBooth = useCallback((fullReset: boolean) => {
    if (!config) return
    clearImages()
    if (fullReset) {
      navigate(`/${config.presetCode}`)
    } else {
      navigate(`/${config.presetCode}/camera`)
    }
  }, [config, navigate, clearImages])

  if (loading || !config) {
    return null
  }

  return (
    <PicView
      config={config}
      uploadCode={uploadCode}
      presentation={presentation}
      reset={resetBooth}
    />
  )
}

export default PicPage